import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_WP_ERROR_HEADING]: 'Unexpected Error',
  [StringId.DV_DP_WP_ERROR]: 'An error has occurred. Please try again later.',
  [StringId.DV_DP_WP_END_HEADING]: 'Watch party ended',
  [StringId.DV_DP_WP_END]: 'The host has ended this Watch Party. You can create your own Watch Party or watch this video below.',
  [StringId.DV_DP_WP_STREAM_ENDED]: 'Create a new Watch Party or watch the video by yourself.',
  [StringId.DV_DP_WP_CREATE_INELIGIBLE_HEADING]: 'Cannot create Watch Party',
  [StringId.DV_DP_WP_CREATE_INELIGIBLE]: 'To create a Watch Party for this video, subscribe to Prime.',
  [StringId.DV_DP_WP_JOIN_INELIGIBLE_HEADING]: 'Cannot join Watch Party',
  [StringId.DV_DP_WP_JOIN_INELIGIBLE]: 'To join this Watch Party, subscribe to Prime',
  [StringId.DV_DP_WP_GEO_RESTRICTION_HEADING]: 'Cannot join Watch Party',
  [StringId.DV_DP_WP_GEO_RESTRICTION]: 'Watch Party is currently only available in the US',
  [StringId.DV_DP_WP_UNSUPPORTED_BROWSER_HEADING]: 'Watch Party unavailable',
  [StringId.DV_DP_WP_UNSUPPORTED_BROWSER]: 'Browser or device not supported',
}



